<template>
    <BreadCrumb PageTitle=" Détail la file" />
    <DetailFile />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
import DetailFile from "@/components/File/DetailFile.vue";
  
    export default defineComponent({
      name: "DetailFilePage",
      components: {
        BreadCrumb,
        DetailFile,
      },
    });
  </script>